(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rz-pdp-proof-band"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-rk-review-bridge]').forEach((bridge) => {
      if (bridge.dataset.rkReviewBridgeInitialized === 'true') return;
      bridge.dataset.rkReviewBridgeInitialized = 'true';

      const standardRatingCount = Number(bridge.dataset.rkStandardRatingCount || 0);
      const ratingCountPattern = /\b[1-9]\d*\s+avalia(?:ç|c)(?:ão|ao|ões|oes)\b/i;
      const storeCopy = bridge.querySelector('[data-rk-store-review-copy]');
      const productCopy = bridge.querySelector('[data-rk-product-review-copy]');
      const productActions = bridge.querySelector('[data-rk-product-review-actions]');
      const bridgeLabel = bridge.querySelector('[data-rk-review-bridge-label]');

      const hasAReviewsRating = () => [...document.querySelectorAll('.areviews_header_stars')].some((node) => {
        return ratingCountPattern.test(node.textContent || '');
      });

      const getAReviewsSections = () => {
        const sections = new Set(document.querySelectorAll('[id^="shopify-section-"][id*="areviews"]'));
        document.querySelectorAll('#az_reviews').forEach((node) => {
          const section = node.closest('[id^="shopify-section-"]');
          if (section) sections.add(section);
        });
        return [...sections];
      };

      const setVisible = (element, visible) => {
        element.hidden = !visible;
        if (visible) {
          element.style.removeProperty('display');
        } else {
          element.style.setProperty('display', 'none', 'important');
        }
      };

      const isReviewSubmissionOpen = () => {
        return document.documentElement.dataset.rkReviewSubmissionOpen === 'true';
      };

      const syncReviewExperience = () => {
        const hasProductReviews = standardRatingCount > 0 || hasAReviewsRating();

        document.querySelectorAll('[data-rk-product-rating-summary]').forEach((summary) => {
          setVisible(summary, hasProductReviews);
        });

        document.querySelectorAll('[data-testimonial-carousel]').forEach((carousel) => {
          setVisible(carousel, !hasProductReviews);
        });

        getAReviewsSections().forEach((section) => {
          setVisible(section, hasProductReviews || isReviewSubmissionOpen());
        });

        storeCopy.hidden = hasProductReviews;
        productCopy.hidden = !hasProductReviews;
        productActions.hidden = !hasProductReviews;
        bridge.href = hasProductReviews ? '#az_reviews' : '#rk-store-testimonials';
        bridge.setAttribute('aria-label', hasProductReviews ? bridge.dataset.rkProductAria : bridge.dataset.rkStoreAria);
        const nextLabel = hasProductReviews ? bridge.dataset.rkProductLabel : bridge.dataset.rkStoreLabel;
        if (bridgeLabel.textContent !== nextLabel) bridgeLabel.textContent = nextLabel;

        return hasProductReviews;
      };

      const openReviewForm = () => {
        document.documentElement.dataset.rkReviewSubmissionOpen = 'true';
        syncReviewExperience();

        let attempts = 0;
        const revealAndOpen = () => {
          attempts += 1;
          const sections = getAReviewsSections();
          sections.forEach((section) => setVisible(section, true));

          const target = document.querySelector('#az_reviews') || sections[0];
          if (!target) {
            if (attempts < 10) window.setTimeout(revealAndOpen, 250);
            return;
          }

          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          const controls = [...target.querySelectorAll('button, a, [role="button"]')];
          const writeReviewControl = controls.find((control) => {
            return /(?:escreva|deixe|adicionar)\s+(?:uma\s+)?avalia(?:ç|c)(?:ão|ao)/i.test(control.textContent || '');
          });

          if (writeReviewControl) {
            window.setTimeout(() => writeReviewControl.click(), 350);
          } else if (attempts < 10) {
            window.setTimeout(revealAndOpen, 250);
          }
        };

        revealAndOpen();
      };

      syncReviewExperience();
      document.addEventListener('rk:open-review-form', openReviewForm);

      const reviewObserver = new MutationObserver(syncReviewExperience);
      reviewObserver.observe(document.body, { childList: true, subtree: true, characterData: true });
      window.setTimeout(() => {
        syncReviewExperience();
        reviewObserver.disconnect();
      }, 12000);
    });
  } catch(e) { console.error(e); }
})();

})();
